/**
 * Filter for company Name it the name is too long
 */
var filter = function () {
    return function (input) {
        var output = input;
        if (output.length > 32) {
            return output.substring(0, 32) + "...";
        }
        else {
            return output;
        }
    };
};
var ɵ0 = filter;
export var CompanyNameSettingFilter = {
    name: 'companyNameSettingFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-company-name-setting.filter.js.map